import React from "react";

const FeatureSection: React.FC = () => {
    return(
        <section className="relative bg-gray-100 min-h-screen flex flex-col lg:flex-row px-8 lg:px-24 py-16 items-stretch">
  {/* Left Section */}
  <div className="lg:w-1/2 flex flex-col justify-around space-y-6 ">
    <div className="flex items-center space-x-2">
      <span className="p-2 bg-purple-100 rounded-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="h-6 w-6 text-purple-500"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v18m9-9H3" />
        </svg>
      </span>
      <p className="text-gray-700 font-semibold">Courses We Offer</p>
    </div>

    <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 text-start">
    An Intro to Technical Analysis and Understanding the Stock Market 
    </h1>

    <p className="text-gray-600 text-start">
    A comprehensive 7 hour seminar course in Toronto covering introductory concepts of  the North American Equity stock market.
    </p>

    <div className="lg:flex-row flex flex-col gap-3 lg:gap-2">
    <button className="px-6 py-3 bg-[#4285F4] w-fit text-white rounded-lg shadow hover:bg-purple-100 hover:text-black transition">
       Course Packages →
    </button>
    <button className="px-6 py-3 bg-[#4285F4] w-fit text-white rounded-lg shadow hover:bg-purple-100 hover:text-black transition">
      Membership Packages →
    </button>
    </div>
  </div>

  {/* Right Section */}
  <div className="lg:w-1/2 grid grid-cols-1 mt-16 lg:mt-0 px-5">
    {[
      {
        id: "01",
        title: "Learn through interactive communication and discussion around a boardroom table",
        text: "Students will learn in an interactive style boardroom limited to 6 persons,  gaining hands-on knowledge of diverse aspects of technical analysis, charting tools, and in-depth understanding of indicators, broader markets, risk management & swing trading techniques.",
      },
      {
        id: "02",
        title: "Learn by consistent practice.",
        text: "Students are asked to bring their laptops to engage directly with charting applications to learn by doing.",
      },
      {
        id: "03",
        title: "Learn forever to walk on the path to mastery.",
        text: "We believe in teaching you to use lifelong tools that will allow you to become a more informed, effective, and profitable investor and/or trader.",
      },
    ].map((feature, index) => (
      <div
        key={feature.id}
        className={`relative flex flex-col ${
          index % 2 === 0 ? "items-start text-left" : "items-end text-right"
        }`}
      >
        <span className="block mt-2 text-6xl font-bold text-gray-200">
          {feature.id}
        </span>
        <h3 className="text-lg font-semibold text-gray-900">{feature.title}</h3>
        <p className="text-sm text-gray-600 mt-2 w-80">{feature.text}</p>
        <span className="block mt-4 w-16 h-1 bg-googleBlue-500"></span>
      </div>
    ))}
  </div>
</section>



    )
}
export default FeatureSection;